const useSearchResultsHelper = () => {
  const getCombinedResults = (normalResultsPlain: Array<any>|null, alternativeResultsStrategies: Array<any>|null): Array<any> => {
    const combinedResults = []
    for (const item of (normalResultsPlain ?? [])) {
      combinedResults.push(item)
    }
    if (!alternativeResultsStrategies) {
      return combinedResults
    }
    for (const strategy of alternativeResultsStrategies) {
      if (!strategy?.plain) {
        continue
      }
      for (const item of strategy.plain) {
        combinedResults.push(item)
      }
    }
    return combinedResults
  }

  return {
    getCombinedResults
  }
}

// export { useObjectHelper }
export default useSearchResultsHelper
